import { render, staticRenderFns } from "./BestArticle.vue?vue&type=template&id=0a8df51a&scoped=true"
import script from "./BestArticle.vue?vue&type=script&lang=js"
export * from "./BestArticle.vue?vue&type=script&lang=js"
import style0 from "./BestArticle.vue?vue&type=style&index=0&id=0a8df51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8df51a",
  null
  
)

export default component.exports